// @ts-ignore
import { SUBJECTS_SLUGS } from '@yandex-int/k-common/constants';
import { SUBJECT_LIBRARY_TAB_SLUG } from '@yandex-int/k-common/typings';
import { SubjectsItemClientData } from '@yandex-int/k-common/typings/api/models/main-page';
import { BackgroundImage, H4, useStaticUrls, useGeneratePath, SimpleCallback } from 'platform-components';
import { UI_KIT_HEADER_TYPOGRAPHY } from 'platform-components/src/components/constants';
import React from 'react';
import { useHistory, useParams } from 'react-router';
import { accessibleClick } from '@edu-frontend/modules/src/shared/lib/a11y';

import './subjects__item.scss';

interface Props {
    item: SubjectsItemClientData;
    onClick?: SimpleCallback;
}

export const SubjectsWidgetItemView = (props: Props) => {
    const { item, onClick } = props;
    const { subject_slug: subject, visual_settings: viewSettings } = item;
    const { imageSrc, name } = viewSettings || {};
    const staticUrls = useStaticUrls();
    const generatePath = useGeneratePath();
    const history = useHistory();
    const { classId } = useParams<{ classId: string }>();

    const handleClick = () => {
        if (subject === SUBJECTS_SLUGS.informatics) {
            const path = classId ? staticUrls.labClassLibrarySubjectTab : staticUrls.deepLabLibrary;
            history.push(
                `${generatePath(path, { subject, tabSlug: SUBJECT_LIBRARY_TAB_SLUG.CONTAINER })}${
                    history.location.search
                }`
            );
        } else {
            const path = classId ? staticUrls.labLibrarySubject : staticUrls.deepLabLibrary;
            history.push(`${generatePath(path, { subject })}${history.location.search}`);
        }

        if (onClick) {
            onClick();
        }
    };

    return (
        <div className="subjects-widget__item" {...accessibleClick(handleClick)}>
            <div className="subjects-widget__item-name">
                <H4 typography={UI_KIT_HEADER_TYPOGRAPHY.headlineXSBold}>{name}</H4>
            </div>
            <BackgroundImage src={imageSrc} />
        </div>
    );
};
